<ng-container *transloco="let t">
  <div class="flex h-[70vh] w-[90vw] flex-col gap-4 2xl:w-[65rem]">
    <div>
      @if (modalData.accessMode === UserAccessMode.UPDATE_ACCESS) {
        <div>
          <div class="font-semibold text-gray-700">{{ modalData.userName }}</div>
          <div class="text-sm font-medium text-gray-500">{{ modalData.userEmail }}</div>
        </div>
      }
      @if (modalData.accessMode === UserAccessMode.ADD_ACCESS) {
        @if (isEmailRegistered() === false) {
          <div class="mb-3">
            <IAlert [title]="t('manage-authorized-access-modal.email_description')" />
          </div>
        }
        <form [formGroup]="emailForm">
          <div class="w-1/2">
            <IInput
              [label]="t('common.email')"
              placeholder="email@example.com"
              [control]="emailForm.controls.email"
              [error]="
                emailForm.controls.email.errors?.['email']
                  ? t('register.email_invalid_error')
                  : emailForm.controls.email.errors?.['isAdmin']
                    ? t('manage-authorized-users-modal.is_already_admin')
                    : emailForm.controls.email.errors?.['isAuthorizedUser']
                      ? t('manage-authorized-users-modal.is_already_authorized_user')
                      : null
              "
              size="sm"
              autoFocus
            />
          </div>
        </form>
      }
    </div>

    <div class="flex flex-auto flex-col gap-2">
      <span class="text-sm font-medium tracking-tight text-gray-600">
        {{ t("account-setting.manage_access") }}
      </span>

      <IInput
        class="w-1/2"
        size="sm"
        [placeholder]="t('manage-authorized-access-modal.filter_by_account_name')"
        (valueChange)="accountNameFilter.set($event); externalFilterChanged($event)"
      />

      <div class="ag-theme-quartz ag-theme-quartz-light flex-1">
        <ag-grid-angular
          [rowData]="manageAccessGridData()"
          class="h-full"
          [gridOptions]="gridOptions"
          [isExternalFilterPresent]="isExternalFilterPresent"
          [doesExternalFilterPass]="doesExternalFilterPass"
        ></ag-grid-angular>
      </div>
    </div>

    <div class="flex justify-end gap-2">
      <IButton [label]="t('common.cancel')" color="white" (onClick)="modalRef.close()" size="sm" />
      <IButton
        [label]="submmitButtonLabel()"
        (onClick)="save()"
        [loading]="grantOrUpdateAccessLoading()"
        [disabled]="emailForm.invalid"
        size="sm"
      />
    </div>
  </div>
</ng-container>
